module.exports = __webpack_public_path__ + "images/emoji/arrow_double_up.647f49c41beeabeed12e.png";